"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const GameBridgeContext_1 = require("./GameBridgeContext");
function useGameBridge() {
    return (0, react_1.useContext)(GameBridgeContext_1.default);
}
exports.default = useGameBridge;
